// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"t7-z"};